import { Navigate } from 'react-router-dom';
import useUserSessionContext from '../hooks/contexts/useUserSessionContext';

interface RoleGuardProps {
  children: React.ReactNode;
  requiredRoles: string[];
  requireAll?: boolean; // Se true, usuário precisa ter todas as roles. Se false, apenas uma
}

const RoleGuard = ({
  children,
  requiredRoles,
  requireAll = false,
}: RoleGuardProps) => {
  const userRoles = useUserSessionContext()

  const hasAccess = requireAll
    ? requiredRoles.every((role) => userRoles.userSession?.roles?.includes(role))
    : requiredRoles.some((role) => userRoles.userSession?.roles?.includes(role));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
